var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_14","data-name":"Group 14","transform":"translate(-291.021 -2302.688)"},React.createElement("path",{"id":"Union_1","data-name":"Union 1","d":"M.261,21.105,0,21.366l.261-.261L0,20.845l.261.261L21.366,0,.261,21.105,21.366,42.211Z","transform":"translate(292.175 2303.395)","fill":"none","stroke":"#00ffe2","strokeWidth":"2"})));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 23.227 43.625"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
